let color = {};

color = require('../data/color')

module.exports = color;